export const routes = {
  LinkPractice: '/link-a-practice',
  NoGenericRegistration: '/no-generic-registration',
  TellUsMore: '/tell-us-more',
  RegistrationMethods: '/registration-methods',
  Name: '/name',
  NameMismatch: '/name-mismatch',
  Birthday: '/birthday',
  PhoneNumber: '/phone-number',
  Email: '/email',
  ConfirmEmail: '/confirm-email',
  EmailConfirmed: '/email-confirmed',
  Username: '/username',
  Password: '/password',
  TOS: '/terms-of-service',
  Success: '/success',
  InviteCode: '/invite-code',
  BusinessCode: '/business-code',
  AlreadyRegistered: '/already-registered',
  SocialAlreadyRegistered: '/social-already-registered',
} as const;

type RegistrationRoute = typeof routes[keyof typeof routes];

export const parseRegistrationRoute = (
  url: string
): RegistrationRoute | null => {
  const route = url.split('/').pop();
  if (
    route &&
    Object.values(routes).includes(`/${route}` as RegistrationRoute)
  ) {
    return `/${route}` as RegistrationRoute;
  }
  return null;
};

const skipToRegistrationRoutes = [
  routes.RegistrationMethods,
  routes.TellUsMore,
];

export const routeCanBeSkippedTo = (
  route: RegistrationRoute
): route is typeof skipToRegistrationRoutes[number] => {
  return skipToRegistrationRoutes.includes(
    route as typeof skipToRegistrationRoutes[number]
  );
};
